import { getOverriddenFlagsFromStorage } from '@myphx-engineering/feature-flags/client';

export const FEATURE_FLAGS_HEADER = 'x-feature-flags';

/**
 * Flag overrides stored in the browser are forwarded to the graph so testers
 * can exercise unreleased behavior. Never sent in production.
 */
export const getFeatureFlagHeaders = (
    isProduction: boolean
): Record<string, string> =>
    isProduction
        ? {}
        : {
              [FEATURE_FLAGS_HEADER]: JSON.stringify(
                  getOverriddenFlagsFromStorage()
              ),
          };
